import React from 'react'
import './styles.scss'
import { sumReduce, toPercent } from '../../functions'

interface Props extends answerTheQuestionProps {}

export const BarChart = ({
  allAnswers,
  userAnswer,
  options,
  correctAnswer
}: Props) => {
  let makeSureAllAreIncluded: { [key: string]: number } = {}
  options?.forEach((o, i) => {
    makeSureAllAreIncluded['option' + (i + 1)] = 0
  })
  allAnswers = { ...makeSureAllAreIncluded, ...allAnswers }
  const opt = options as string[]
  const entries = Object.values(allAnswers).map((m, i) => {
    return [opt[i], m]
  })
  const sum = +entries.map(m => +m[1]).reduce(sumReduce)
  const max = Math.max.apply(
    Math,
    entries.map(m => +m[1])
  )

  //
  const correctIndex = opt.indexOf(correctAnswer as string)
  //

  return (
    <div className='BarChartEstimate'>
      <div className='wrapper'>
        {entries.map((m, i) => {
          return (
            <div
              className={
                'entry' +
                (correctIndex === i
                  ? ' corr'
                  : Object.keys(allAnswers).indexOf(userAnswer) === i
                  ? ' user'
                  : '')
              }
            >
              <div className='namecell'>
                <span>{m[0]}</span>
              </div>
              <div className='barcell'>
                {Object.keys(allAnswers).indexOf(userAnswer) === i && (
                  <img src={require('../../_assets/icons_user.png')} />
                )}
                {correctIndex === i && (
                  <img src={require('../../_assets/icons_correct.png')} />
                )}

                {m[1] > 0 && (
                  <div
                    className='bar'
                    style={{
                      width:
                        (+m[1] * (window.innerWidth < 712 ? 82 : 88)) / max +
                        '%'
                    }}
                  ></div>
                )}
                <div className='barvalue'>{toPercent(+m[1], sum) + '%'}</div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
